// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__fb3O3","input_search":"style_input_search__5JOJJ","btn_search":"style_btn_search__N9zm9","btn_w":"style_btn_w__oz7ML","bs_icon":"style_bs_icon__LP-BI"};